// DocumentsPage.jsx
import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import DocumentItem from '../components/DocumentItem';
import Navbar from '../components/home/Navbar';

const ViewRefLegal = () => {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDocuments = async () => {
      setLoading(true);
      try {
        const querySnapshot = await getDocs(collection(db, 'ref_legal'));
        const data = querySnapshot.docs.map(doc => {
          const docData = doc.data();
          return {
            id: doc.id,
            title: docData.titre,
            link: docData.lien,
            date: new Date(docData.timestamp.toDate()).toLocaleDateString('fr-FR'),
          };
        });
        setDocuments(data);
      } catch (error) {
        console.error("Error fetching documents: ", error);
        alert("An error occurred while fetching documents.");
      } finally {
        setLoading(false);
      }
    };

    fetchDocuments();
  }, []);

  return (
    <div style={pageStyle}>
      <Navbar />
      <div style={containerStyle}>
        <h1 style={headingStyle}>Les Références Juridiques</h1>
        {loading ? (
          <div style={loadingStyle}>
            <div style={spinnerStyle}></div>
            <p>Chargement des Références Juridiques...</p>
          </div>
        ) : (
          <div style={documentsContainerStyle}>
            {documents.length > 0 ? (
              documents.map(document => (
                <DocumentItem
                  key={document.id}
                  title={document.title}
                  link={document.link}
                  date={document.date}
                />
              ))
            ) : (
              <p style={noDocumentsStyle}>Aucun document disponible pour le moment.</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

// Styles
const pageStyle = {
  backgroundColor: '#f0f4f8', // Light grey-blue background
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};

const containerStyle = {
  padding: '20px',
  maxWidth: '1200px',
  width: '100%',
  margin: '20px',
  backgroundColor: '#ffffff',
  borderRadius: '8px',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
};

const headingStyle = {
  fontSize: '2.5rem',
  color: '#ffffff',
  textAlign: 'center',
  marginBottom: '30px',
  fontFamily: 'Chalkboard, Comic Sans MS, cursive, sans-serif',
  backgroundColor: '#00674b',
  padding: '15px 20px',
  borderRadius: '8px',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  textShadow: '1px 1px 2px rgba(0, 0, 0, 0.2)',
};

const documentsContainerStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};

const loadingStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '60vh',
};

const spinnerStyle = {
  border: '8px solid #f3f3f3', /* Light grey */
  borderTop: '8px solid #1f77b4', /* Blue color */
  borderRadius: '50%',
  width: '60px',
  height: '60px',
  animation: 'spin 1s linear infinite',
};

// Add the keyframes in a <style> tag or include them in a CSS file
const spinAnimation = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

// Inject the keyframes into the document head for the animation to work
const style = document.createElement('style');
style.type = 'text/css';
style.innerHTML = spinAnimation;
document.head.appendChild(style);

const noDocumentsStyle = {
  fontSize: '1.2rem',
  color: '#888888',
  textAlign: 'center',
  marginTop: '20px',
};

export default ViewRefLegal;
